import React, { useContext, useEffect, useState } from "react";
import { Card, Label, ModalBody, Badge, Modal, ModalHeader } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    Row,
    OverlineTitle,
    Sidebar,
    UserAvatar,
} from "../../../components/Component";
import { useHistory } from "react-router";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { urlTenantID, currentTime, findUpper, formDataUsername, monthNames, timeStamp, todaysDate } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import TenantTab from "./TenantTab";
import TenantHeading from "./TenantHeading";
import Api from "../../../Api";
import Swal from "sweetalert2";
import { add, cloneDeep, stubObject } from "lodash";

const SMTPsetting = ({ match }) => {
    const { contextData } = useContext(UserContext);
    const [data] = contextData;
    const location = useLocation()
    const [sideBar, setSidebar] = useState(false);
    const [user, setUser] = useState();
    const [noteData, setNoteData] = useState(notes);
    const [addNoteModal, setAddNoteModal] = useState(false);
    const [addNoteText, setAddNoteText] = useState("");
    const history = useHistory();

    const [getTenantId, setGetTenantId] = useState(urlTenantID());
    const [val, setVal] = useState({
        SMTP_SERVER: "",
        SMTP_PORT: "",
        SMTP_USER_NAME: "",
        SMTP_PASSWORD: "",
        SMTP_DEFAULT_FROM_ADDRESS: "",
        SMTP_DEFAULT_FROM_NAME: "",
        IS_SMTP_USE_SSL: true,
    })

    const [prefer, setPrefer] = useState({
        SMTP_SERVER: "",
        SMTP_PORT: "",
        SMTP_USER_NAME: "",
        SMTP_PASSWORD: "",
        SMTP_DEFAULT_FROM_ADDRESS: "",
        SMTP_DEFAULT_FROM_NAME: "",
        IS_SMTP_USE_SSL: "",
    });

    const [mail, setEmail] = useState({
        email: "",
        subject: "",
        message: ""
    });

    const [regex, setRegex] = useState({
        // password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/,
        password: /^.{5,16}$/,
        email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        // ipv4Regex: /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/,
        ipv4Regex: /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        port: /^\d{1,4}$/,
    });

    const [error, setError] = useState({
        SMTP_SERVER: "",
        SMTP_PORT: "",
        SMTP_USER_NAME: "",
        SMTP_PASSWORD: "",
        SMTP_DEFAULT_FROM_ADDRESS: "",
        SMTP_DEFAULT_FROM_NAME: "",
    });

    const [modal, setModal] = useState({
        add: false,
    });

    const [emailErr, setEmailErr] = useState({
        email: "",
        subject: "",
        message: ""
    });

    const areAllEmpty = () => {
        return Object.values(prefer).every(value => value === "");
    };

    // grabs the id of the url and loads the corresponding data

    const getSmtpSettings = async () => {
        let data = JSON?.stringify([
            {
                tenantId: getTenantId,
                keyStr: "SMTP_SERVER",
            },
            {
                tenantId: getTenantId,
                keyStr: "SMTP_PORT",
            },
            {
                tenantId: getTenantId,
                keyStr: "SMTP_USER_NAME",
            },
            {
                tenantId: getTenantId,
                keyStr: "SMTP_PASSWORD",
            },
            {
                tenantId: getTenantId,
                keyStr: "SMTP_DEFAULT_FROM_ADDRESS",
            },
            {
                tenantId: getTenantId,
                keyStr: "SMTP_DEFAULT_FROM_NAME",
            },
            {
                tenantId: getTenantId,
                keyStr: "IS_SMTP_USE_SSL",
            }
        ])
        let response = await Api?.getSmtpSettings(data);
        let res = response?.data?.data;
        if (res !== null) {
            let datas = cloneDeep(val);
            let prefers = cloneDeep(prefer);
            res.forEach(curr => {
                if (curr.keyStr === "IS_SMTP_USE_SSL") {
                    datas[curr.keyStr] = curr.valueStr === "true";
                } else {
                    datas[curr.keyStr] = curr.valueStr || "";
                }
                prefers[curr.keyStr] = curr.tenantPrefId;
            });
            setVal(datas);
            setPrefer(prefers)
        }
    }

    useEffect(() => {
        const id = match.params.id;
        if (id !== undefined || null || "") {
            let spUser = data.find((item) => item.id === Number(id));
            setUser(spUser);
        } else {
            setUser(data[0]);
        }
    }, [match.params.id, data]);

    useEffect(() => {
        getSmtpSettings();
    }, [])

    // function to toggle sidebar
    const toggle = () => {
        setSidebar(!sideBar);
    };

    // delete a note
    const deleteNote = (id) => {
        let defaultNote = noteData;
        defaultNote = defaultNote.filter((item) => item.id !== id);
        setNoteData(defaultNote);
    };

    const submitNote = () => {
        let submitData = {
            id: Math.random(),
            text: addNoteText,
            date: `${monthNames[todaysDate.getMonth()]} ${todaysDate.getDate()}, ${todaysDate.getFullYear()}`,
            time: `${currentTime()}`,
            company: "Softnio",
        };
        setNoteData([...noteData, submitData]);
        setAddNoteModal(false);
        setAddNoteText("");
    };

    const handleChange = (eve) => {
        const { name, value, checked } = eve?.target;
        if (name === "IS_SMTP_USE_SSL") {
            setVal({ ...val, [name]: checked })
        } else {
            setVal({ ...val, [name]: value })
        }
    }

    const isValidForm = (errors) => Object.values(errors)?.every(error => error === "");

    const handleSubmit = async (eve) => {
        eve?.preventDefault();
        let errors = cloneDeep(error);
        errors.SMTP_SERVER = regex.ipv4Regex.test(val.SMTP_SERVER) ? "" : "Enter Valid Host";
        errors.SMTP_PORT = regex.port.test(val.SMTP_PORT) ? "" : "Enter Valid Port";
        errors.SMTP_USER_NAME = val.SMTP_USER_NAME.trim() !== "" ? "" : "This Field is Required.";
        // errors.SMTP_PASSWORD = regex.password.test(val.SMTP_PASSWORD) ? "" : "Enter Valid Password (Contains minimum 1 uppercase, 1 lowercase, 1 number, 1 special character, minimum length 8 and maximum 16).";
        errors.SMTP_PASSWORD = regex.password.test(val.SMTP_PASSWORD) ? "" : "Enter Password from  5 to 8 Characters.";
        errors.SMTP_DEFAULT_FROM_ADDRESS = regex.email.test(val.SMTP_DEFAULT_FROM_ADDRESS) ? "" : "Enter Valid Email Address.";
        errors.SMTP_DEFAULT_FROM_NAME = val.SMTP_DEFAULT_FROM_NAME.trim() !== "" ? "" : "This Field is Required.";

        if (isValidForm(errors)) {
            if (areAllEmpty()) {
                let data = JSON?.stringify([
                    {
                        tenantId: getTenantId,
                        keyStr: "SMTP_SERVER",
                        valueStr: val?.SMTP_SERVER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "SMTP_PORT",
                        valueStr: val?.SMTP_PORT,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "SMTP_USER_NAME",
                        valueStr: val?.SMTP_USER_NAME,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "SMTP_PASSWORD",
                        valueStr: val?.SMTP_PASSWORD,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "SMTP_DEFAULT_FROM_ADDRESS",
                        valueStr: val?.SMTP_DEFAULT_FROM_ADDRESS,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        // tenantPrefId: prefer?.SMTP_DEFAULT_FROM_NAME,
                        keyStr: "SMTP_DEFAULT_FROM_NAME",
                        valueStr: val?.SMTP_DEFAULT_FROM_NAME,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        // tenantPrefId: prefer?.IS_SMTP_USE_SSL,
                        keyStr: "IS_SMTP_USE_SSL",
                        valueStr: val?.IS_SMTP_USE_SSL,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    }
                ]);
                try {
                    let response = await Api?.insertSmtpSettings(data);
                    Swal?.fire({
                        icon: response?.data?.statusCode === 200 ? "success" : "error",
                        title: response?.data?.statusCode === 200 ? "SMTP Setting Updated Succesfully" : "Something Went Wrong"
                    });
                    getSmtpSettings();
                } catch (error) {
                    Swal?.fire({
                        icon: "error",
                        title: "Something Went Wrong"
                    });
                }
            } else {
                let data = JSON?.stringify([
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.SMTP_SERVER,
                        keyStr: "SMTP_SERVER",
                        valueStr: val?.SMTP_SERVER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.SMTP_PORT,
                        keyStr: "SMTP_PORT",
                        valueStr: val?.SMTP_PORT,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.SMTP_USER_NAME,
                        keyStr: "SMTP_USER_NAME",
                        valueStr: val?.SMTP_USER_NAME,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.SMTP_PASSWORD,
                        keyStr: "SMTP_PASSWORD",
                        valueStr: val?.SMTP_PASSWORD,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.SMTP_DEFAULT_FROM_ADDRESS,
                        keyStr: "SMTP_DEFAULT_FROM_ADDRESS",
                        valueStr: val?.SMTP_DEFAULT_FROM_ADDRESS,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.SMTP_DEFAULT_FROM_NAME,
                        keyStr: "SMTP_DEFAULT_FROM_NAME",
                        valueStr: val?.SMTP_DEFAULT_FROM_NAME,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.IS_SMTP_USE_SSL,
                        keyStr: "IS_SMTP_USE_SSL",
                        valueStr: val?.IS_SMTP_USE_SSL,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    }
                ]);
                try {
                    let response = await Api?.insertSmtpSettings(data);
                    Swal?.fire({
                        icon: response?.data?.statusCode === 200 ? "success" : "error",
                        title: response?.data?.statusCode === 200 ? "SMTP Setting Updated Succesfully" : "Something Went Wrong"
                    });
                    getSmtpSettings();
                } catch (error) {
                    Swal?.fire({
                        icon: "error",
                        title: "Something Went Wrong"
                    });
                }
            }
        }
        setError(errors);
    }

    const handleTestEmail = async (eve) => {
        eve?.preventDefault();

        let errors = cloneDeep(error);

        errors.SMTP_SERVER = val.SMTP_SERVER !== "" ? "" : "Enter Valid Host";
        errors.SMTP_PORT = regex.port.test(val.SMTP_PORT) ? "" : "Enter Valid Port";
        errors.SMTP_USER_NAME = val.SMTP_USER_NAME.trim() !== "" ? "" : "This Field is Required.";
        errors.SMTP_PASSWORD = val.SMTP_PASSWORD !== "" ? "" : "Enter Valid Password (Contains minimum 1 uppercase, 1 lowercase, 1 number, 1 special character, minimum length 8 and maximum 16).";
        errors.SMTP_DEFAULT_FROM_ADDRESS = regex.email.test(val.SMTP_DEFAULT_FROM_ADDRESS) ? "" : "Enter Valid Email Address.";
        errors.SMTP_DEFAULT_FROM_NAME = val.SMTP_DEFAULT_FROM_NAME.trim() !== "" ? "" : "This Field is Required.";
        if (isValidForm(errors)) {
            getSmtpSettings();
            setModal({ ...modal, add: true });
        }

        setError(errors);

    }

    const handlePostEmail = async (eve) => {
        eve?.preventDefault();
        let errors = cloneDeep(emailErr);
        errors.email = (regex?.email)?.test(mail?.email) ? "" : "Enter Valid Email.";
        errors.subject = (mail?.subject)?.trim() !== "" ? "" : "This Field is Required.";
        errors.message = (mail?.message)?.trim() !== "" ? "" : "This Field is Required.";
        if (isValidForm(errors)) {
            let data = JSON?.stringify({
                "tenantID": getTenantId,
                "smtpServer": val?.SMTP_SERVER,
                "smtpPort": val?.SMTP_PORT,
                "smtpUserName": val?.SMTP_USER_NAME,
                "smtpPassword": val?.SMTP_PASSWORD, //SMTP_PASSWORD
                "smtpssl": val?.IS_SMTP_USE_SSL, //TRUE //IS_SMTP_USE_SSL
                "sendToEmailId": mail?.email,
                "emailSubject": mail?.subject,
                "emailBody": mail?.message
            });
            try {
                let response = await Api?.sendEmail(data);
                Swal?.fire({
                    icon: (response?.data?.statusCode === 200 || response?.data?.statusCode === 205) ? "success" : "error",
                    title: (response?.data?.statusCode === 200 || response?.data?.statusCode === 205) ? "Email Sended Succesfully" : "Something Went Wrong",
                });
                setModal({ ...modal, add: false });
                setEmail({ ...mail, email: "", subject: "", message: "" });
            } catch (error) {
                Swal?.fire({
                    icon: "error",
                    title: "Something Went Wrong",
                });
            }

        }
        setEmailErr(errors);
    }
    const handleChangemail = (eve) => {
        const { name, value } = eve?.target;
        setEmail({ ...mail, [name]: value });
    }

    const onFormCancel = () => {
        setModal({ ...modal, add: false })
    }

    return (
        <React.Fragment>
            <Head title="User Details - Regular"></Head>
            {user && (
                <Content>
                    <TenantHeading heading={"Add Tenant Detail"} />
                    <TenantTab match={match} />
                    <Block>
                        <Card className="card-bordered">
                            <div className="card-aside-wrap" id="user-detail-block">
                                <div className="card-content">
                                    <div className="card-inner">
                                        <Block>
                                            <h4 className="mb-3">SMTP Settings</h4>
                                            <form onSubmit={handleSubmit}>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="first-name">
                                                                Host
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" name="SMTP_SERVER" id="first-name" value={val?.SMTP_SERVER} onChange={handleChange} />
                                                                {error.SMTP_SERVER && <span className="invalid">{error.SMTP_SERVER}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Port
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" name="SMTP_PORT" id="middle-name" value={val?.SMTP_PORT} onChange={handleChange} />
                                                                {error.SMTP_PORT && <span className="invalid">{error.SMTP_PORT}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="first-name">
                                                                User Name
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" id="first-name" name="SMTP_USER_NAME" value={val?.SMTP_USER_NAME} onChange={handleChange} />
                                                                {error.SMTP_USER_NAME && <span className="invalid">{error.SMTP_USER_NAME}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Password
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="password" id="middle-name" name="SMTP_PASSWORD" value={val?.SMTP_PASSWORD} onChange={handleChange} minLength={5} maxLength={16} />
                                                                {error.SMTP_PASSWORD && <span className="invalid">{error.SMTP_PASSWORD}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="first-name">
                                                                SMTP Default address
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="email" id="first-name" name="SMTP_DEFAULT_FROM_ADDRESS" value={val?.SMTP_DEFAULT_FROM_ADDRESS} onChange={handleChange} />
                                                                {error.SMTP_DEFAULT_FROM_ADDRESS && <span className="invalid">{error.SMTP_DEFAULT_FROM_ADDRESS}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                SMTP Default from name
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" id="middle-name" name="SMTP_DEFAULT_FROM_NAME" value={val?.SMTP_DEFAULT_FROM_NAME} onChange={handleChange} />
                                                                {error.SMTP_DEFAULT_FROM_NAME && <span className="invalid">{error.SMTP_DEFAULT_FROM_NAME}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="custom-control custom-switch">
                                                            <input type="checkbox" className="custom-control-input" name="IS_SMTP_USE_SSL" onChange={handleChange} id="customSwitch2" checked={val?.IS_SMTP_USE_SSL} />
                                                            <label className="custom-control-label text-dark" htmlFor="customSwitch2">
                                                                Security TLS
                                                            </label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div>
                                                    <Button color="primary" type="submit" onClick={handleTestEmail} className="me-3">Test Email</Button>
                                                </div>
                                                <div className="justify-end">
                                                    <Button color="primary" type="submit" className="me-3" onClick={handleSubmit}>Save</Button>
                                                </div>
                                            </form>
                                        </Block>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Block>

                    <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
                        <ModalHeader
                            close={
                                <button className="close" href="#close"
                                    onClick={(ev) => {
                                        ev.preventDefault();
                                        onFormCancel();
                                    }}>
                                    <Icon name="cross" />
                                </button>
                            }
                        >
                            Email Test
                        </ModalHeader>
                        <ModalBody>
                            <form onSubmit={eve => handlePostEmail(eve)} autoComplete="off">
                                <Row className="mb-3">
                                    <Col md="12">
                                        <div className="form-group">
                                            <label className="form-label">To </label>
                                            <input
                                                onChange={handleChangemail}
                                                value={mail?.email}
                                                className="form-control bg-blue-dim"
                                                type="text"
                                                name="email"
                                                placeholder="Enter name"
                                            />
                                            {emailErr?.email && <span className="invalid">{emailErr?.email}</span>}
                                        </div>
                                    </Col>

                                    <Col md="12">
                                        <div className="form-group">
                                            <label className="form-label">Subject </label>
                                            <input
                                                onChange={handleChangemail}
                                                value={mail?.subject}
                                                className="form-control bg-blue-dim"
                                                type="text"
                                                name="subject"
                                                placeholder="Enter name"
                                            />
                                            {emailErr?.subject && <span className="invalid">{emailErr?.subject}</span>}
                                        </div>
                                    </Col>


                                    <Col md="12">
                                        <div className="form-group">
                                            <label className="form-label">Content </label>
                                            <textarea
                                                onChange={handleChangemail}
                                                value={mail?.message}
                                                className="form-control bg-blue-dim"
                                                type="text"
                                                name="message"
                                                placeholder="Enter name"
                                            />
                                            {emailErr?.message && <span className="invalid">{emailErr?.message}</span>}
                                        </div>
                                    </Col>


                                </Row>

                                <div className="justify-end">
                                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                                        <li>
                                            <Button color="primary" size="md" type="submit">
                                                Save
                                            </Button>
                                        </li>
                                        <li>
                                            <a
                                                href="#cancel"
                                                onClick={(ev) => {
                                                    ev.preventDefault();
                                                    onFormCancel();
                                                }}
                                                className="link link-light"
                                            >
                                                Cancel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </form>
                        </ModalBody>
                    </Modal>
                </Content>
            )}
        </React.Fragment>
    );
};
export default SMTPsetting;
